import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Bot, Building2, FileText, FolderKanban, Network, ShieldCheck } from "lucide-react";
import MarketingLayout from "@/components/public/MarketingLayout";
import PublicBreadcrumb from "@/components/public/PublicBreadcrumb";
import { Button } from "@/components/ui/button";

const productFeatures = [
  { icon: FolderKanban, title: "Template e checklist", body: "Framework nativi, import da CSV/Excel e generazione checklist da testo normativo." },
  { icon: Network, title: "Workflow multi-tenant", body: "Ruoli distinti per admin, consulente e azienda con isolamento dati e accessi approvati." },
  { icon: FileText, title: "Reportistica professionale", body: "Relazioni finali, verbali custom, export Word/PDF e branding per tenant." },
  { icon: Bot, title: "AI controllabile", body: "Report AI, prompt personalizzati, BYOK OpenAI e flussi scalabili per consulenti." },
  { icon: Building2, title: "Portafoglio clienti", body: "Per i consulenti: aziende collegate, richieste accesso e gestione audit per cliente." },
  { icon: ShieldCheck, title: "Governance e storico", body: "Audit versionati, score per framework e storicizzazione delle revisioni." },
];

export default function ProductPage() {
  return (
    <MarketingLayout>
      <section className="mx-auto max-w-7xl px-5 pb-16 pt-16 md:px-8 md:pt-24">
        <div className="max-w-3xl">
          <PublicBreadcrumb currentLabel="Prodotto" />
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-sky-700">Prodotto</div>
          <h1 className="mt-4 font-display text-5xl font-black leading-tight text-slate-950 md:text-6xl">Il software che struttura il tuo metodo di audit e lo rende vendibile come servizio.</h1>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">Audit Pro non e solo una dashboard. E un flusso completo per impostare, eseguire, documentare e vendere audit compliance con output chiari per clienti, board e management.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {productFeatures.map((feature) => (
            <div key={feature.title} className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm">
              <feature.icon className="h-6 w-6 text-sky-600" />
              <h2 className="mt-5 font-display text-2xl font-bold text-slate-950">{feature.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{feature.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-20 md:px-8">
        <div className="rounded-[32px] bg-[#0f172a] p-8 text-white md:p-12">
          <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr]">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.24em] text-sky-200"><BadgeCheck className="h-3.5 w-3.5" /> Per studi e aziende</div>
              <h2 className="mt-5 font-display text-4xl font-black leading-tight">Due superfici, un'unica architettura: sito pubblico per vendere, app riservata per operare.</h2>
            </div>
            <div className="space-y-4 text-sm leading-relaxed text-slate-300">
              <p>La parte pubblica deve convincere, raccontare casi d'uso e guidare verso la conversione. La parte autenticata deve restare densa, veloce e orientata al lavoro operativo.</p>
              <p>Per questo la riprogettazione che sto costruendo separa marketing site, pricing e billing dal workspace di audit, mantenendo pero una coerenza forte di brand e linguaggio.</p>
              <Button asChild size="lg" className="mt-4 rounded-full bg-white px-6 text-slate-950 hover:bg-slate-100">
                <Link to="/pricing">Vai ai piani <ArrowRight className="h-4 w-4" /></Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
